<template>
  <form class="d-grid gap-3" :action="createActionUrl">
    <component :is="componentForField(field.name)" v-for="field of fieldsToInclude" v-show="shouldShowField(field)"
               v-bind="fieldProps(field)" :key="field.name" entity-name="signature"
               :validation-errors="validationErrorsForField(field.name)"
               @changed="(value) => updateField(field.name, value, field.isAdditionalField)" />

    <!-- Used on scenarios to check the status of one-click signing -->
    <input type="hidden" name="signature[one_click_from_crm_status]" :value="oneClickFromCrmStatus">

    <bot-protected-submit-button ref="submitButton" :label="submitButtonText" :submitting-label="submittingText"
                                 :submit-in-progress="submittingCreateAction" captcha-action="signature_create"
                                 :validation-errors="validationErrors" button-class="btn btn-primary btn-lg w-100"
                                 @submit="submit" />
  </form>
</template>

<script>
import FormMixin from '@/campaign-action-shared/form-mixin'
import { mapGetters, mapState } from 'vuex'
import WriteToDecisionMaker from './write-to-decision-maker'

export default {
  components: { WriteToDecisionMaker },

  mixins: [ FormMixin ],

  computed: {
    ...mapGetters(['oneClickSigning', 'submitButtonText']),
    ...mapState(['oneClickFromCrmStatus', 'petition', 'retryingSubmit']),

    entityType() {
      return 'signature'
    },

    submittingText() {
      if (this.petition.signersWriteToDecisionMaker) {
        return this.i18n.t('buttons.sending')
      }
      else {
        return this.i18n.t('buttons.signing')
      }
    }
  },

  watch: {
    retryingSubmit() {
      if (this.retryingSubmit) {
        this.$refs.submitButton.recalculateAndResubmit()
      }
    }
  },

  methods: {
    componentForField(fieldName) {
      if (fieldName === 'messageToTarget') {
        return WriteToDecisionMaker
      } else {
        return this.componentForCommonField(fieldName)
      }
    },

    extraPropsForField(fieldConfig) {
      switch (fieldConfig.name) {
      case 'country':
        return {
          countryOptions: fieldConfig.options,
          geoipHostname: this.agraConfiguration.geoipHostname,
          inputId: 'signature_country',
          inputName: 'signature[country]',
          label: fieldConfig.label
        }
      case 'firstName':
        return {
          labelOverride: fieldConfig.label
        }
      case 'lastName':
        return {
          labelOverride: fieldConfig.label
        }
      case 'messageToTarget':
        return {
          decisionMaker: fieldConfig.decisionMaker,
          instructionsHtml: fieldConfig.instructionsHtml,
          subjectLocked: fieldConfig.subjectLocked
        }
      default:
        return this.extraPropsForCommonField(fieldConfig)
      }
    },

    submit({ friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken }) {
      this.$store.dispatch('saveNewAction', { friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken })
    },

    updateField(fieldName, value, isAdditionalField) {
      this.updateCommonField({fieldName, value, isAdditionalField})
    }
  }
}
</script>
